import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=14da856b&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=14da856b&prod&scoped=true&lang=scss&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=14da856b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14da856b",
  null
  
)

export default component.exports